import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ff45f1fe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ff45f1fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff45f1fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff45f1fe')) {
      api.createRecord('ff45f1fe', component.options)
    } else {
      api.reload('ff45f1fe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ff45f1fe&scoped=true", function () {
      api.rerender('ff45f1fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/lossRateStats/index.vue"
export default component.exports